export default {
    methods: {
        updateUltimaVersao(version) {
            localStorage.setItem('ultimaVersaoCompraDireta', version)
        },

        getUltimaVersao() {
            const ultimaVersao = localStorage.getItem('ultimaVersaoCompraDireta')
            return ultimaVersao || '5.5.8'
        },

        updateVisualizacaoNovidade(situacao) {
            localStorage.setItem('estadoNovidades', situacao)
        },

        getVisualizacaoNovidade() {
            return localStorage.getItem('estadoNovidades')
        },

        haNovidades(compraDireta) {
            const versaoAtual = compraDireta.version
            const versaoAnterior = this.getUltimaVersao()

            const parteVersaoAtual = versaoAtual.split('.')
            const parteVersaoAnterior = versaoAnterior.split('.')

            return Number.parseInt(parteVersaoAtual[0]) > Number.parseInt(parteVersaoAnterior[0])
                || Number.parseInt(parteVersaoAtual[1]) > Number.parseInt(parteVersaoAnterior[1])
        },
    }
}